import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import {
  fetchAssignees,
  fetchLeadSources,
  fetchProjects,
  fetchStatus,
} from "../../../../components/CommonFunctions/DropdownLists";
import SelectX from "../../../../components/Form/SelectX";
import DateIn from "../../../../components/Form/Date";



export default function Filters({
  open,
  setOpen,
  watch,
  control,
  reset,
  handleFilter,
  setFilterData,
  setValue,
  selectedChats,
  setSelectedChats}) {
  const [leadSource, setLeadSource] = React.useState([]);
  const handleClose = () => {
   
    setOpen(false);

  };
  const handleCleare = () => {
    
    if(selectedChats.length > 0){
        setSelectedChats([]);
    }
    setFilterData(null);
    reset();
    setValue("assing_to_users", null);
    setValue("lead_source", null);
    setValue("projects", null);
    setValue("status", null);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth={true}
        PaperProps={{
          style: {
            minHeight: "200px",
            minWidth: "100px",
          },
        }}
      >
        <Grid display={"flex"} justifyContent={"space-between"} paddingTop={1}>
          <DialogTitle
            style={{ fontSize: 20, paddingTop: 13, paddingBottom: 10 }}
          >
            Filters
          </DialogTitle>
          <IconButton onClick={handleClose} sx={{ marginRight: 3 }}>
            <CloseIcon />
          </IconButton>
        </Grid>

        <DialogContent>
          <Grid container spacing={2} sx={{ display: "flex", mt: 0 }}>
                 <Grid item xs={12} sm={6}>
                                        <DateIn
                                            control={control}
                                            name="from"
                                            label="From"
                                            value={watch('from')}
            
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <DateIn
                                            control={control}
                                            name="to"
                                            label="To"
                                            value={watch('to')}
            
                                        />
                                    </Grid>
            <Grid item xs={12} sm={6}>
              <SelectX
                ismultiple
                options={fetchAssignees}
                label="Assigned User"
                name={"assing_to_users"}
                defaultValue={watch("assing_to_users")}
                control={control}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  // singleValue: (base, state) => {
                  //     return {
                  //         ...base,
                  //         backgroundColor: state.data.bg_color,
                  //         fill: state.data.text_color
                  //     };
                  // },

                  multiValue: (base, state) => {
                    return {
                      ...base,
                      backgroundColor: state.data.bg_color,
                      fill: state.data.text_color,
                    };
                  },

                  multiValueLabel: (base, state) => ({
                    ...base,
                    backgroundColor: "hsl(0, 0%, 90%)",
                    color: state.data.text_color,
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    color: "black",
                    backgroundColor: "hsl(0, 0%, 90%)",
                  }),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <SelectX
                options={fetchLeadSources}
                label="Lead Source"
                name={"lead_source"}
                ismultiple
                defaultValue={watch("lead_source")}
                control={control}
                isSearchable={false}
                hideSelectedOptions={false}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  multiValue: (base, state) => {
                    return {
                      ...base,
                      backgroundColor: state.data.bg_color,
                      fill: state.data.text_color,
                    };
                  },

                  multiValueLabel: (base, state) => ({
                    ...base,
                    backgroundColor: "hsl(0, 0%, 90%)",
                    color: state.data.text_color,
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    color: "black",
                    backgroundColor: "hsl(0, 0%, 90%)",
                  }),
                }}
              />
            </Grid>
               <Grid item xs={12} sm={6}>
              <SelectX
                options={fetchProjects}
                label="Project"
                name={"project"}
          closeMenuOnSelect={true}
                defaultValue={watch("project")}
                control={control}
                isSearchable={false}
                hideSelectedOptions={false}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  multiValue: (base, state) => {
                    return {
                      ...base,
                      backgroundColor: state.data.bg_color,
                      fill: state.data.text_color,
                    };
                  },

                  multiValueLabel: (base, state) => ({
                    ...base,
                    backgroundColor: "hsl(0, 0%, 90%)",
                    color: state.data.text_color,
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    color: "black",
                    backgroundColor: "hsl(0, 0%, 90%)",
                  }),
                }}
              />
            </Grid>
                  <Grid item xs={12} sm={6}>
              <SelectX
                options={fetchStatus}
                label="Status"
                name={"status"}
          closeMenuOnSelect={true}
                defaultValue={watch("status")}
                control={control}
                isSearchable={false}
                hideSelectedOptions={false}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  multiValue: (base, state) => {
                    return {
                      ...base,
                      backgroundColor: state.data.bg_color,
                      fill: state.data.text_color,
                    };
                  },

                  multiValueLabel: (base, state) => ({
                    ...base,
                    backgroundColor: "hsl(0, 0%, 90%)",
                    color: state.data.text_color,
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    color: "black",
                    backgroundColor: "hsl(0, 0%, 90%)",
                  }),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button color="error" variant="outlined" onClick={handleCleare}>
            Clear
          </Button>

          <Button variant="outlined" onClick={handleFilter}>
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
